<script setup lang="ts">
import type { Music } from '~/services/musicService'
import { generateFullSlug } from '~/utils/string'
import MmShareDialog from '../base/MmShareDialog.vue'
import { useShareIntent } from '../creator/incentives/useShareIntent'
const props = defineProps<{ song: Music | null; heading?: string }>()
const emit = defineEmits<{ close: []; shared: [] }>()
const { t } = useI18n(), intent = useShareIntent()
const url = ref(''), pending = ref(false), failed = ref(''), copied = ref(false), copyFailed = ref(false)
let request = 0
const siteUrl = String(useRuntimeConfig().public.siteUrl || 'https://musicmint.ai').replace(/\/$/, '')
function reset() { request++; intent.finish(); url.value=''; pending.value=false; failed.value=''; copied.value=false; copyFailed.value=false }
const prepare = async () => {
  const song=props.song; if(!song||pending.value) return
  const version=++request, context=intent.version(); url.value='';failed.value='';copied.value=false;copyFailed.value=false;pending.value=true
  try { const response=await intent.generate({id:song.id}); if(version!==request||!intent.isCurrent(context)) return; url.value=`${siteUrl}/share/${generateFullSlug(response.data!.token!,song.title)}` }
  catch(error) { if(version===request&&intent.isCurrent(context)) failed.value=t(intent.errorKey(error)) }
  finally { if(version===request) pending.value=false }
}
// Props only reset presentation. A click on Create link is the explicit write intent.
watch([()=>props.song?.id,intent.identity,intent.locale],reset)
onBeforeUnmount(reset)
const copy = async () => {
  if(!url.value) return
  const version=request, context=intent.version(), value=url.value
  try { await navigator.clipboard.writeText(value); if(version===request&&intent.isCurrent(context)&&value===url.value) {copied.value=true;copyFailed.value=false;emit('shared')} }
  catch { if(version===request&&intent.isCurrent(context)) copyFailed.value=true }
}
</script>
<template>
  <MmShareDialog :model-value="!!song" :song="song" :title="heading" :url="url" :pending="pending" :action-label="!failed ? t('incShare.createLink') : undefined" :error="failed || (copyFailed ? t('ux.shareCopyFailed') : '')" :copied="copied" @update:model-value="reset(); emit('close')" @copy="copy" @retry="prepare" @shared="emit('shared')" />
</template>
